
(function() {
  var result = { translations: { "el": { "i18n": { "duration": { "seconds": "{{ seconds }} \u03B4\u03B5\u03C5\u03C4.", "minutes": "{{ minutes }} \u03BB\u03B5\u03C0\u03C4.", "hours": "{{ hours }} \u03CE\u03C1.", "hoursAndMinutes": "{{ hours }} \u03CE\u03C1. {{ minutes }} \u03BB\u03B5\u03C0\u03C4.", "days": "{{ days }} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2", "shortForm": { "seconds": "{{ seconds }}\u03B4.", "minutes": "{{ minutes }}\u03BB.", "hours": "{{ hours }}\u03CE\u03C1.", "days": "{{ days }}\u03B7\u03BC.", "hoursAndMinutes": "{{ hours }}\u03CE\u03C1. {{ minutes }}\u03BB." } }, "dateTime": { "quarterAndYear": "{{quarterNumber}}\u03BF \u03C4\u03C1\u03AF\u03BC. {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u03B5\u03C3\u03C9\u03C4. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "el": "static-7.1050"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1050",
    "ar-eg": "static-7.1050",
    "bg": "static-7.1050",
    "bn": "static-7.1050",
    "ca-es": "static-7.1050",
    "cs": "static-7.1050",
    "da": "static-7.1050",
    "de": "static-7.1050",
    "el": "static-7.1050",
    "en-gb": "static-7.1050",
    "en": "static-7.1050",
    "es-mx": "static-7.1050",
    "es": "static-7.1050",
    "et": "static-7.1050",
    "fi": "static-7.1050",
    "fr-ca": "static-7.1050",
    "fr": "static-7.1050",
    "he-il": "static-7.1050",
    "hi": "static-7.1050",
    "hr": "static-7.1050",
    "hu": "static-7.1050",
    "id": "static-7.1050",
    "it": "static-7.1050",
    "ja": "static-7.1050",
    "ko": "static-7.1050",
    "lt": "static-7.1050",
    "ms": "static-7.1050",
    "nl": "static-7.1050",
    "no": "static-7.1050",
    "pl": "static-7.1050",
    "pt-br": "static-7.1050",
    "pt-pt": "static-7.1050",
    "ro": "static-7.1050",
    "ru": "static-7.1050",
    "sk": "static-7.1050",
    "sl": "static-7.1050",
    "sv": "static-7.1050",
    "th": "static-7.1050",
    "tl": "static-7.1050",
    "tr": "static-7.1050",
    "uk": "static-7.1050",
    "vi": "static-7.1050",
    "x-pseudo": "static-7.1050",
    "zh-cn": "static-7.1050",
    "zh-hk": "static-7.1050",
    "zh-tw": "static-7.1050"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:el', {version: 'static-7.1050'}); }
})();


